import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_behavior_proto from './dcei_engine_behavior_proto';
export class Upgrade {
  get descriptor() {
    return Upgrade.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._effectModifications = [];
  }
  isEmpty() {
    if (this._effectModifications.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Upgrade) {
      return value;
    }
    return Upgrade.fromJson(value);
  }
  static fromJson(json) {
    const result = new Upgrade();
    result._effectModifications = JsonToList(json.effectModifications, EffectModification);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._effectModifications.length > 0) {
      result.effectModifications = ArrayToJson(this._effectModifications, EffectModification);
    }
    return result;
  }
  /**
   * @returns {EffectModification[]}
   */
  get effectModifications() {
    return this._effectModifications;
  }
  addEffectModifications(path, value) {
    return {type: 'ADD', path: path.concat(['effectModifications']), value: value.toJson()};
  }
  setEffectModifications(path, value) {
    return {type: 'SET', path: path.concat(['effectModifications']), value: ArrayToJson(value, EffectModification)};
  }
  setEffectModificationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['effectModifications', key]), value: value.toJson()};
  }
  deleteEffectModifications(path) {
    return {type: 'DELETE', path: path.concat(['effectModifications'])};
  }
  deleteEffectModificationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['effectModifications', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "effectModifications": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Upgrade(this);
              copy._effectModifications = [];        for (let i of value) {
                copy._effectModifications.push(EffectModification.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Upgrade(this);
              copy._effectModifications = copy._effectModifications.concat([EffectModification.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._effectModifications.length === 0) {
                return this;
              }
              const copy = new Upgrade(this);
              copy._effectModifications = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._effectModifications.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Upgrade(this);
              copy._effectModifications = copy._effectModifications.slice();
              copy._effectModifications[path[1]] = EffectModification.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Upgrade(this);
              copy._effectModifications = copy._effectModifications.slice(0, path[1]).concat(copy._effectModifications.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._effectModifications.length) {
            return this;
          }
          const oldValue = this._effectModifications[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Upgrade(this);
          copy._effectModifications = copy._effectModifications.slice();
          copy._effectModifications[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Upgrade} other
   * @returns {Upgrade}
   */
  merge(other) {
    const copy = new Upgrade(this);
    copy._effectModifications = this._effectModifications.concat(other._effectModifications);
    return copy;
  }
}
Upgrade.default = new Upgrade();
class Upgrade_Builder {
  constructor(value) {
    this._value = new Upgrade(value);
  }
  build() {
    return new Upgrade(this._value);
  }
  addAllEffectModifications(values) {
    this._value._effectModifications = this._value._effectModifications.concat(values);
    return this;
  }
  addEffectModifications(value) {
    this._value._effectModifications = this._value._effectModifications.concat([value]);
    return this;
  }
  setEffectModifications(index, value) {
    this._value._effectModifications = this._value._effectModifications.concat();
    this._value._effectModifications[index] = value;
    return this;
  }
  clearEffectModifications() {
    this._value._effectModifications = [];
    return this;
  }
}
Upgrade.Builder = Upgrade_Builder;
class Upgrade_WithParent {
  /**
   * @param {Upgrade} value
   * @param {Upgrade_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Upgrade.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfEffectModifications() {
    if (!this._selfEffectModifications) {
      this._selfEffectModifications = [];
      for (let i of this._value.effectModifications) {
        this._selfEffectModifications.push(new EffectModification.WithParent(i, null));
      }
    }
    return this._selfEffectModifications;
  }
  get inherentEffectModifications() {
    if (!this._inherentEffectModifications) {
      this._inherentEffectModifications = this._parent ? this._parent.effectModifications : [];
    }
    return this._inherentEffectModifications;
  }
  get effectModifications() {
    if (!this._allEffectModifications) {
      this._allEffectModifications = this._parent ? this._parent.effectModifications.concat(this.selfEffectModifications) : this.selfEffectModifications;
    }
    return this._allEffectModifications;
  }
  update(current, parent) {
    const result = new Upgrade_WithParent(current, parent);
    if (this._selfEffectModifications) {
      if (this._value.effectModifications === current.effectModifications) {
        result._selfEffectModifications = this._selfEffectModifications;
      } else {
        result._selfEffectModifications = [];
        for (let i = 0; i < current.effectModifications.length; i++) {
          const oldValue = this._value.effectModifications[i];
          if (oldValue) {
            const oldCache = this._selfEffectModifications[i];
            if (oldValue === current.effectModifications[i]) {
              result._selfEffectModifications[i] = oldCache;
            } else {
              result._selfEffectModifications[i] = oldCache.update(current.effectModifications[i], null);
            }
          } else {
            result._selfEffectModifications[i] = new EffectModification.WithParent(current.effectModifications[i], null);
          }
        }
      }
    }
    return result;
  }
}
Upgrade_WithParent.default = new Upgrade_WithParent(Upgrade.default, null);
Upgrade.WithParent = Upgrade_WithParent;
class Upgrade_Descriptor {
  get effectModifications() {
    if (!this._effectModifications) {
      this._effectModifications = {
        name: "effectModifications",
        Name: "EffectModifications",
        number: 3,
        protoType: 11,
        protoName: "effect_modifications",
        type: EffectModification,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effectModifications;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.effectModifications,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
Upgrade.descriptor = new Upgrade_Descriptor();
export class EffectModification {
  get descriptor() {
    return EffectModification.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasEffect = false;
    this._effect = null;
    this._hasModification = false;
    this._modification = null;
  }
  isEmpty() {
    if (this._hasEffect) return false;
    if (this._hasModification && !this._modification.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EffectModification) {
      return value;
    }
    return EffectModification.fromJson(value);
  }
  static fromJson(json) {
    const result = new EffectModification();
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.modification != null) {
      result._hasModification = true;
      result._modification = Modification.fromJson(json.modification);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasModification && !this._modification.isEmpty()) {
      result.modification = Modification.toJson(this._modification);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {Modification}
   */
  get modification() {
    return this._hasModification ? this._modification : Modification.default;
  }
  get hasModification() {
    return this._hasModification;
  }
  setModification(path, value) {
    return {type: 'SET', path: path.concat(['modification']), value: value.toJson()};
  }
  deleteModification(path) {
    return {type: 'DELETE', path: path.concat(['modification'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModification(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new EffectModification(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modification": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EffectModification(this);
              copy._hasModification = true;
              copy._modification = Modification.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModification) {
                return this;
              }
              const copy = new EffectModification(this);
              copy._hasModification = false;
              copy._modification = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasModification) {
            const copy = new EffectModification(this);
            copy._hasModification = true;
            copy._modification = Modification.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._modification.apply(type, path.slice(1), value);
          if (newValue === this._modification) {
            return this;
          }
          const copy = new EffectModification(this);
          copy._modification = copy._modification.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EffectModification} other
   * @returns {EffectModification}
   */
  merge(other) {
    const copy = new EffectModification(this);
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasModification) {
      if (copy._hasModification) {
        copy._modification = copy.modification.merge(other.modification);
      } else {
        copy._modification = other._modification;
      }
      copy._hasModification = true;
    }
    return copy;
  }
}
EffectModification.default = new EffectModification();
class EffectModification_Builder {
  constructor(value) {
    this._value = new EffectModification(value);
  }
  build() {
    return new EffectModification(this._value);
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setModification(value) {
    this._value._hasModification = true;
    this._value._modification = value;
    return this;
  }
  deleteModification() {
    this._value._hasModification = false;
    this._value._modification = null;
    return this;
  }
}
EffectModification.Builder = EffectModification_Builder;
class EffectModification_WithParent {
  /**
   * @param {EffectModification} value
   * @param {EffectModification_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EffectModification.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasModification() {
    if (this._cachedHasModification === undefined) {
      if (this._value.hasModification) {
        this._cachedHasModification = true;
      } else {
        this._cachedHasModification = this._parent ? this._parent.hasModification : false;
      }
    }
    return this._cachedHasModification;
  }
  get modification() {
    if (!this._cachedModification) {
      if (this._value.hasModification) {
        this._cachedModification = new Modification.WithParent(this._value.modification, this._parent && this._parent.hasModification ? this._parent.modification : null);
      } else {
        this._cachedModification = this._parent ? new Modification.WithParent(Modification.default, this._parent.modification) : Modification.WithParent.default;
      }
    }
    return this._cachedModification;
  }
  update(current, parent) {
    const result = new EffectModification_WithParent(current, parent);
    if (this._cachedModification && this._value.hasModification && current.hasModification) {
      if (this._value.modification === current.modification && this._parent === parent) {
        result._cachedModification = this._cachedModification;
      } else {
        result._cachedModification = this._cachedModification.update(current.modification, parent && parent.hasModification ? parent.modification : null);
      }
    }
    return result;
  }
}
EffectModification_WithParent.default = new EffectModification_WithParent(EffectModification.default, null);
EffectModification.WithParent = EffectModification_WithParent;
class EffectModification_Descriptor {
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 1,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get modification() {
    if (!this._modification) {
      this._modification = {
        name: "modification",
        Name: "Modification",
        number: 2,
        protoType: 11,
        protoName: "modification",
        type: Modification,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modification;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.effect,
        this.modification,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModification",
        Name: "DummyOneofForModification",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
EffectModification.descriptor = new EffectModification_Descriptor();
class Modification_ModificationValue {
  get descriptor() {
    return Modification_ModificationValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._valueTypeCase = 0;
    this._valueTypeValue = null;
  }
  isEmpty() {
    if (this._valueTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Modification_ModificationValue) {
      return value;
    }
    return Modification_ModificationValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new Modification_ModificationValue();
    if (json.boolValue != null) {
      result._valueTypeCase = 1;
      result._valueTypeValue = JsonToBoolean.fromJson(json.boolValue);
    }
    if (json.int32Value != null) {
      result._valueTypeCase = 2;
      result._valueTypeValue = JsonToInt32.fromJson(json.int32Value);
    }
    if (json.doubleValue != null) {
      result._valueTypeCase = 3;
      result._valueTypeValue = JsonToDouble.fromJson(json.doubleValue);
    }
    if (json.stringValue != null) {
      result._valueTypeCase = 4;
      result._valueTypeValue = JsonToString.fromJson(json.stringValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._valueTypeCase) {
      case 1:
        result.boolValue = JsonToBoolean.toJson(this._valueTypeValue);
        break;
      case 2:
        result.int32Value = JsonToInt32.toJson(this._valueTypeValue);
        break;
      case 3:
        result.doubleValue = JsonToDouble.toJson(this._valueTypeValue);
        break;
      case 4:
        result.stringValue = JsonToString.toJson(this._valueTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get valueTypeCase() {
    return this._valueTypeCase;
  }
  deleteValueType(path) {
    switch (this._valueTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['boolValue'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['int32Value'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['doubleValue'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['stringValue'])};
      }
    }
  }
  /**
   * @returns {boolean}
   */
  get boolValue() {
    return this._valueTypeCase === 1 ? this._valueTypeValue : JsonToBoolean.default;
  }
  setBoolValue(path, value) {
    return {type: 'SET', path: path.concat(['boolValue']), value};
  }
  deleteBoolValue(path) {
    return {type: 'DELETE', path: path.concat(['boolValue'])};
  }
  /**
   * @returns {number}
   */
  get int32Value() {
    return this._valueTypeCase === 2 ? this._valueTypeValue : JsonToInt32.default;
  }
  setInt32Value(path, value) {
    return {type: 'SET', path: path.concat(['int32Value']), value};
  }
  deleteInt32Value(path) {
    return {type: 'DELETE', path: path.concat(['int32Value'])};
  }
  /**
   * @returns {number}
   */
  get doubleValue() {
    return this._valueTypeCase === 3 ? this._valueTypeValue : JsonToDouble.default;
  }
  setDoubleValue(path, value) {
    return {type: 'SET', path: path.concat(['doubleValue']), value};
  }
  deleteDoubleValue(path) {
    return {type: 'DELETE', path: path.concat(['doubleValue'])};
  }
  /**
   * @returns {string}
   */
  get stringValue() {
    return this._valueTypeCase === 4 ? this._valueTypeValue : JsonToString.default;
  }
  setStringValue(path, value) {
    return {type: 'SET', path: path.concat(['stringValue']), value};
  }
  deleteStringValue(path) {
    return {type: 'DELETE', path: path.concat(['stringValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "boolValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 1;
              copy._valueTypeValue = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 1) {
                return this;
              }
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "int32Value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 2;
              copy._valueTypeValue = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 2) {
                return this;
              }
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "doubleValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 3;
              copy._valueTypeValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 3) {
                return this;
              }
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stringValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 4;
              copy._valueTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 4) {
                return this;
              }
              const copy = new Modification_ModificationValue(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Modification_ModificationValue} other
   * @returns {Modification_ModificationValue}
   */
  merge(other) {
    const copy = new Modification_ModificationValue(this);
    if (other._valueTypeCase === 1) {
      copy._valueTypeCase = 1;
      copy._valueTypeValue = other._valueTypeValue;
    }
    if (other._valueTypeCase === 1) {
      copy._valueTypeCase = 1;
      copy._valueTypeValue = other._valueTypeValue;
    }
    if (other._valueTypeCase === 1) {
      copy._valueTypeCase = 1;
      copy._valueTypeValue = other._valueTypeValue;
    }
    if (other._valueTypeCase === 1) {
      copy._valueTypeCase = 1;
      copy._valueTypeValue = other._valueTypeValue;
    }
    return copy;
  }
}
Modification_ModificationValue.default = new Modification_ModificationValue();
class Modification_ModificationValue_Builder {
  constructor(value) {
    this._value = new Modification_ModificationValue(value);
  }
  build() {
    return new Modification_ModificationValue(this._value);
  }
  clearvalueType() {
    this._value._valueTypeCase = 0;
    this._value._valueTypeValue = null;
    return this;
  }
  setBoolValue(value) {
    this._value._valueTypeCase = 1;
    this._value._valueTypeValue = value;
    return this;
  }
  setInt32Value(value) {
    this._value._valueTypeCase = 2;
    this._value._valueTypeValue = value;
    return this;
  }
  setDoubleValue(value) {
    this._value._valueTypeCase = 3;
    this._value._valueTypeValue = value;
    return this;
  }
  setStringValue(value) {
    this._value._valueTypeCase = 4;
    this._value._valueTypeValue = value;
    return this;
  }
}
Modification_ModificationValue.Builder = Modification_ModificationValue_Builder;
class Modification_ModificationValue_WithParent {
  /**
   * @param {Modification_ModificationValue} value
   * @param {Modification_ModificationValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Modification_ModificationValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get valueTypeCase() {
    if (this._cachedvalueTypeCase === undefined) {
      if (this._value._valueTypeCase === 0) {
        this._cachedvalueTypeCase = this._parent ? this._parent.valueTypeCase : 0;
      } else {
        this._cachedvalueTypeCase = this._value._valueTypeCase;
      }
    }
    return this._cachedvalueTypeCase;
  }
  get boolValue() {
    if (!this._cachedBoolValue) {
      if (this._value._valueTypeCase === 0) {
        this._cachedBoolValue = this._parent ? this._parent.boolValue : this._value.boolValue;
      } else {
        this._cachedBoolValue = this._value.boolValue;
      }
    }
    return this._cachedBoolValue;
  }
  get int32Value() {
    if (!this._cachedInt32Value) {
      if (this._value._valueTypeCase === 0) {
        this._cachedInt32Value = this._parent ? this._parent.int32Value : this._value.int32Value;
      } else {
        this._cachedInt32Value = this._value.int32Value;
      }
    }
    return this._cachedInt32Value;
  }
  get doubleValue() {
    if (!this._cachedDoubleValue) {
      if (this._value._valueTypeCase === 0) {
        this._cachedDoubleValue = this._parent ? this._parent.doubleValue : this._value.doubleValue;
      } else {
        this._cachedDoubleValue = this._value.doubleValue;
      }
    }
    return this._cachedDoubleValue;
  }
  get stringValue() {
    if (!this._cachedStringValue) {
      if (this._value._valueTypeCase === 0) {
        this._cachedStringValue = this._parent ? this._parent.stringValue : this._value.stringValue;
      } else {
        this._cachedStringValue = this._value.stringValue;
      }
    }
    return this._cachedStringValue;
  }
  update(current, parent) {
    const result = new Modification_ModificationValue_WithParent(current, parent);
    return result;
  }
}
Modification_ModificationValue_WithParent.default = new Modification_ModificationValue_WithParent(Modification_ModificationValue.default, null);
Modification_ModificationValue.WithParent = Modification_ModificationValue_WithParent;
class Modification_ModificationValue_Descriptor {
  get boolValue() {
    if (!this._boolValue) {
      this._boolValue = {
        name: "boolValue",
        Name: "BoolValue",
        number: 1,
        protoType: 8,
        protoName: "bool_value",
        oneofIndex: 0,
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boolValue;
  }
  get int32Value() {
    if (!this._int32Value) {
      this._int32Value = {
        name: "int32Value",
        Name: "Int32Value",
        number: 2,
        protoType: 5,
        protoName: "int32_value",
        oneofIndex: 0,
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._int32Value;
  }
  get doubleValue() {
    if (!this._doubleValue) {
      this._doubleValue = {
        name: "doubleValue",
        Name: "DoubleValue",
        number: 3,
        protoType: 1,
        protoName: "double_value",
        oneofIndex: 0,
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._doubleValue;
  }
  get stringValue() {
    if (!this._stringValue) {
      this._stringValue = {
        name: "stringValue",
        Name: "StringValue",
        number: 4,
        protoType: 9,
        protoName: "string_value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stringValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.boolValue,
        this.int32Value,
        this.doubleValue,
        this.stringValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "valueType",
        Name: "ValueType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
Modification_ModificationValue.descriptor = new Modification_ModificationValue_Descriptor();
class Modification_ModificationType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "SET": return 0;
        case "ADD": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Modification_ModificationType.fromJson(value);
  }
  static fromReact(e) {
    return Modification_ModificationType.fromJson(e);
  }
}
Modification_ModificationType.SET = 0;
Modification_ModificationType.ADD = 1;
Modification_ModificationType.default = 0;
Modification_ModificationType.values = {
  SET: 0,
  ADD: 1,
};
Modification_ModificationType.names = {
  0: "SET",
  1: "ADD",
};
export class Modification {
  get descriptor() {
    return Modification.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._path = [];
    this._hasType = false;
    this._type = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._path.length > 0) return false;
    if (this._hasType) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Modification) {
      return value;
    }
    return Modification.fromJson(value);
  }
  static fromJson(json) {
    const result = new Modification();
    result._path = JsonToList(json.path, JsonToString);
    if (json.type != null) {
      result._hasType = true;
      result._type = Modification_ModificationType.fromJson(json.type);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = Modification_ModificationValue.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._path.length > 0) {
      result.path = ArrayToJson(this._path, JsonToString);
    }
    if (this._hasType) {
      result.type = Modification_ModificationType.toJson(this._type);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = Modification_ModificationValue.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get path() {
    return this._path;
  }
  addPath(path, value) {
    return {type: 'ADD', path: path.concat(['path']), value};
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value: ArrayToJson(value, JsonToString)};
  }
  setPathByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['path', key]), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  deletePathByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['path', key])};
  }
  /**
   * @returns {number}
   */
  get type() {
    return this._hasType ? this._type : Modification_ModificationType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {Modification_ModificationValue}
   */
  get value() {
    return this._hasValue ? this._value : Modification_ModificationValue.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification(this);
              copy._path = [];        for (let i of value) {
                copy._path.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Modification(this);
              copy._path = copy._path.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._path.length === 0) {
                return this;
              }
              const copy = new Modification(this);
              copy._path = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._path.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Modification(this);
              copy._path = copy._path.slice();
              copy._path[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Modification(this);
              copy._path = copy._path.slice(0, path[1]).concat(copy._path.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._path.length) {
            return this;
          }
          const oldValue = this._path[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Modification(this);
          copy._path = copy._path.slice();
          copy._path[key] = newValue;
          return copy;
        }
      }
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification(this);
              copy._hasType = true;
              copy._type = Modification_ModificationType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new Modification(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Modification(this);
              copy._hasValue = true;
              copy._value = Modification_ModificationValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new Modification(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new Modification(this);
            copy._hasValue = true;
            copy._value = Modification_ModificationValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new Modification(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Modification} other
   * @returns {Modification}
   */
  merge(other) {
    const copy = new Modification(this);
    copy._path = this._path.concat(other._path);
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
Modification.default = new Modification();
Modification.ModificationValue = Modification_ModificationValue;
Modification.ModificationType = Modification_ModificationType;
class Modification_Builder {
  constructor(value) {
    this._value = new Modification(value);
  }
  build() {
    return new Modification(this._value);
  }
  addAllPath(values) {
    this._value._path = this._value._path.concat(values);
    return this;
  }
  addPath(value) {
    this._value._path = this._value._path.concat([value]);
    return this;
  }
  setPath(index, value) {
    this._value._path = this._value._path.concat();
    this._value._path[index] = value;
    return this;
  }
  clearPath() {
    this._value._path = [];
    return this;
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
Modification.Builder = Modification_Builder;
class Modification_WithParent {
  /**
   * @param {Modification} value
   * @param {Modification_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Modification.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfPath() {
    return this._value.path;
  }
  get inherentPath() {
    if (!this._inherentPath) {
      this._inherentPath = this._parent ? this._parent.path : [];
    }
    return this._inherentPath;
  }
  get path() {
    if (!this._allPath) {
      this._allPath = this._parent ? this._parent.path.concat(this.selfPath) : this.selfPath;
    }
    return this._allPath;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new Modification_ModificationValue.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new Modification_ModificationValue.WithParent(Modification_ModificationValue.default, this._parent.value) : Modification_ModificationValue.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new Modification_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
Modification_WithParent.default = new Modification_WithParent(Modification.default, null);
Modification.WithParent = Modification_WithParent;
class Modification_Descriptor {
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 1,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 2,
        protoType: 14,
        protoName: "type",
        type: Modification_ModificationType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 3,
        protoType: 11,
        protoName: "value",
        type: Modification_ModificationValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.path,
        this.type,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
Modification.descriptor = new Modification_Descriptor();
export class DataUpgrade {
  get descriptor() {
    return DataUpgrade.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLevel = false;
    this._level = null;
    this._upgrades = [];
  }
  isEmpty() {
    if (this._hasLevel) return false;
    if (this._upgrades.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataUpgrade) {
      return value;
    }
    return DataUpgrade.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataUpgrade();
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    result._upgrades = JsonToList(json.upgrades, DataFieldUpgrade);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._upgrades.length > 0) {
      result.upgrades = ArrayToJson(this._upgrades, DataFieldUpgrade);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {DataFieldUpgrade[]}
   */
  get upgrades() {
    return this._upgrades;
  }
  addUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['upgrades']), value: value.toJson()};
  }
  setUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['upgrades']), value: ArrayToJson(value, DataFieldUpgrade)};
  }
  setUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['upgrades', key]), value: value.toJson()};
  }
  deleteUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['upgrades'])};
  }
  deleteUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['upgrades', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataUpgrade(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new DataUpgrade(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataUpgrade(this);
              copy._upgrades = [];        for (let i of value) {
                copy._upgrades.push(DataFieldUpgrade.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataUpgrade(this);
              copy._upgrades = copy._upgrades.concat([DataFieldUpgrade.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._upgrades.length === 0) {
                return this;
              }
              const copy = new DataUpgrade(this);
              copy._upgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._upgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataUpgrade(this);
              copy._upgrades = copy._upgrades.slice();
              copy._upgrades[path[1]] = DataFieldUpgrade.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataUpgrade(this);
              copy._upgrades = copy._upgrades.slice(0, path[1]).concat(copy._upgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._upgrades.length) {
            return this;
          }
          const oldValue = this._upgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataUpgrade(this);
          copy._upgrades = copy._upgrades.slice();
          copy._upgrades[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataUpgrade} other
   * @returns {DataUpgrade}
   */
  merge(other) {
    const copy = new DataUpgrade(this);
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    copy._upgrades = this._upgrades.concat(other._upgrades);
    return copy;
  }
}
DataUpgrade.default = new DataUpgrade();
class DataUpgrade_Builder {
  constructor(value) {
    this._value = new DataUpgrade(value);
  }
  build() {
    return new DataUpgrade(this._value);
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  addAllUpgrades(values) {
    this._value._upgrades = this._value._upgrades.concat(values);
    return this;
  }
  addUpgrades(value) {
    this._value._upgrades = this._value._upgrades.concat([value]);
    return this;
  }
  setUpgrades(index, value) {
    this._value._upgrades = this._value._upgrades.concat();
    this._value._upgrades[index] = value;
    return this;
  }
  clearUpgrades() {
    this._value._upgrades = [];
    return this;
  }
}
DataUpgrade.Builder = DataUpgrade_Builder;
class DataUpgrade_WithParent {
  /**
   * @param {DataUpgrade} value
   * @param {DataUpgrade_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataUpgrade.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get selfUpgrades() {
    if (!this._selfUpgrades) {
      this._selfUpgrades = [];
      for (let i of this._value.upgrades) {
        this._selfUpgrades.push(new DataFieldUpgrade.WithParent(i, null));
      }
    }
    return this._selfUpgrades;
  }
  get inherentUpgrades() {
    if (!this._inherentUpgrades) {
      this._inherentUpgrades = this._parent ? this._parent.upgrades : [];
    }
    return this._inherentUpgrades;
  }
  get upgrades() {
    if (!this._allUpgrades) {
      this._allUpgrades = this._parent ? this._parent.upgrades.concat(this.selfUpgrades) : this.selfUpgrades;
    }
    return this._allUpgrades;
  }
  update(current, parent) {
    const result = new DataUpgrade_WithParent(current, parent);
    if (this._selfUpgrades) {
      if (this._value.upgrades === current.upgrades) {
        result._selfUpgrades = this._selfUpgrades;
      } else {
        result._selfUpgrades = [];
        for (let i = 0; i < current.upgrades.length; i++) {
          const oldValue = this._value.upgrades[i];
          if (oldValue) {
            const oldCache = this._selfUpgrades[i];
            if (oldValue === current.upgrades[i]) {
              result._selfUpgrades[i] = oldCache;
            } else {
              result._selfUpgrades[i] = oldCache.update(current.upgrades[i], null);
            }
          } else {
            result._selfUpgrades[i] = new DataFieldUpgrade.WithParent(current.upgrades[i], null);
          }
        }
      }
    }
    return result;
  }
}
DataUpgrade_WithParent.default = new DataUpgrade_WithParent(DataUpgrade.default, null);
DataUpgrade.WithParent = DataUpgrade_WithParent;
class DataUpgrade_Descriptor {
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 1,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get upgrades() {
    if (!this._upgrades) {
      this._upgrades = {
        name: "upgrades",
        Name: "Upgrades",
        number: 2,
        protoType: 11,
        protoName: "upgrades",
        type: DataFieldUpgrade,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upgrades;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.level,
        this.upgrades,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
DataUpgrade.descriptor = new DataUpgrade_Descriptor();
class DataFieldUpgrade_ValueType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "ADDITIVE": return 0;
        case "SCALED": return 1;
        case "SET": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return DataFieldUpgrade_ValueType.fromJson(value);
  }
  static fromReact(e) {
    return DataFieldUpgrade_ValueType.fromJson(e);
  }
}
DataFieldUpgrade_ValueType.ADDITIVE = 0;
DataFieldUpgrade_ValueType.SCALED = 1;
DataFieldUpgrade_ValueType.SET = 2;
DataFieldUpgrade_ValueType.default = 0;
DataFieldUpgrade_ValueType.values = {
  ADDITIVE: 0,
  SCALED: 1,
  SET: 2,
};
DataFieldUpgrade_ValueType.names = {
  0: "ADDITIVE",
  1: "SCALED",
  2: "SET",
};
export class DataFieldUpgrade {
  get descriptor() {
    return DataFieldUpgrade.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValueType = false;
    this._valueType = null;
    this._hasValueGainsPerLevel = false;
    this._valueGainsPerLevel = null;
    this._assignedValueTypeCase = 0;
    this._assignedValueTypeValue = null;
    this._path = [];
  }
  isEmpty() {
    if (this._hasValueType) return false;
    if (this._hasValueGainsPerLevel) return false;
    if (this._assignedValueTypeCase !== 0) return false;
    if (this._path.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DataFieldUpgrade) {
      return value;
    }
    return DataFieldUpgrade.fromJson(value);
  }
  static fromJson(json) {
    const result = new DataFieldUpgrade();
    if (json.valueType != null) {
      result._hasValueType = true;
      result._valueType = DataFieldUpgrade_ValueType.fromJson(json.valueType);
    }
    if (json.valueGainsPerLevel != null) {
      result._hasValueGainsPerLevel = true;
      result._valueGainsPerLevel = JsonToDouble.fromJson(json.valueGainsPerLevel);
    }
    if (json.floatValue != null) {
      result._assignedValueTypeCase = 4;
      result._assignedValueTypeValue = JsonToDouble.fromJson(json.floatValue);
    }
    if (json.stringValue != null) {
      result._assignedValueTypeCase = 5;
      result._assignedValueTypeValue = JsonToString.fromJson(json.stringValue);
    }
    result._path = JsonToList(json.path, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValueType) {
      result.valueType = DataFieldUpgrade_ValueType.toJson(this._valueType);
    }
    if (this._hasValueGainsPerLevel) {
      result.valueGainsPerLevel = JsonToDouble.toJson(this._valueGainsPerLevel);
    }
    switch (this._assignedValueTypeCase) {
      case 4:
        result.floatValue = JsonToDouble.toJson(this._assignedValueTypeValue);
        break;
      case 5:
        result.stringValue = JsonToString.toJson(this._assignedValueTypeValue);
        break;
      default:
        break;
    }
    if (this._path.length > 0) {
      result.path = ArrayToJson(this._path, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get valueType() {
    return this._hasValueType ? this._valueType : DataFieldUpgrade_ValueType.default;
  }
  get hasValueType() {
    return this._hasValueType;
  }
  setValueType(path, value) {
    return {type: 'SET', path: path.concat(['valueType']), value};
  }
  deleteValueType(path) {
    return {type: 'DELETE', path: path.concat(['valueType'])};
  }
  /**
   * @returns {number}
   */
  get valueGainsPerLevel() {
    return this._hasValueGainsPerLevel ? this._valueGainsPerLevel : JsonToDouble.default;
  }
  get hasValueGainsPerLevel() {
    return this._hasValueGainsPerLevel;
  }
  setValueGainsPerLevel(path, value) {
    return {type: 'SET', path: path.concat(['valueGainsPerLevel']), value};
  }
  deleteValueGainsPerLevel(path) {
    return {type: 'DELETE', path: path.concat(['valueGainsPerLevel'])};
  }
  get assignedValueTypeCase() {
    return this._assignedValueTypeCase;
  }
  deleteAssignedValueType(path) {
    switch (this._assignedValueTypeCase) {
      default:
      case 4: {
        return {type: 'DELETE', path: path.concat(['floatValue'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['stringValue'])};
      }
    }
  }
  /**
   * @returns {number}
   */
  get floatValue() {
    return this._assignedValueTypeCase === 4 ? this._assignedValueTypeValue : JsonToDouble.default;
  }
  setFloatValue(path, value) {
    return {type: 'SET', path: path.concat(['floatValue']), value};
  }
  deleteFloatValue(path) {
    return {type: 'DELETE', path: path.concat(['floatValue'])};
  }
  /**
   * @returns {string}
   */
  get stringValue() {
    return this._assignedValueTypeCase === 5 ? this._assignedValueTypeValue : JsonToString.default;
  }
  setStringValue(path, value) {
    return {type: 'SET', path: path.concat(['stringValue']), value};
  }
  deleteStringValue(path) {
    return {type: 'DELETE', path: path.concat(['stringValue'])};
  }
  /**
   * @returns {string[]}
   */
  get path() {
    return this._path;
  }
  addPath(path, value) {
    return {type: 'ADD', path: path.concat(['path']), value};
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value: ArrayToJson(value, JsonToString)};
  }
  setPathByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['path', key]), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  deletePathByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['path', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "valueType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFieldUpgrade(this);
              copy._hasValueType = true;
              copy._valueType = DataFieldUpgrade_ValueType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueType) {
                return this;
              }
              const copy = new DataFieldUpgrade(this);
              copy._hasValueType = false;
              copy._valueType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "valueGainsPerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFieldUpgrade(this);
              copy._hasValueGainsPerLevel = true;
              copy._valueGainsPerLevel = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValueGainsPerLevel) {
                return this;
              }
              const copy = new DataFieldUpgrade(this);
              copy._hasValueGainsPerLevel = false;
              copy._valueGainsPerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "floatValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFieldUpgrade(this);
              copy._assignedValueTypeCase = 4;
              copy._assignedValueTypeValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._assignedValueTypeCase !== 4) {
                return this;
              }
              const copy = new DataFieldUpgrade(this);
              copy._assignedValueTypeCase = 0;
              copy._assignedValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stringValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFieldUpgrade(this);
              copy._assignedValueTypeCase = 5;
              copy._assignedValueTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._assignedValueTypeCase !== 5) {
                return this;
              }
              const copy = new DataFieldUpgrade(this);
              copy._assignedValueTypeCase = 0;
              copy._assignedValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DataFieldUpgrade(this);
              copy._path = [];        for (let i of value) {
                copy._path.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DataFieldUpgrade(this);
              copy._path = copy._path.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._path.length === 0) {
                return this;
              }
              const copy = new DataFieldUpgrade(this);
              copy._path = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._path.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DataFieldUpgrade(this);
              copy._path = copy._path.slice();
              copy._path[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DataFieldUpgrade(this);
              copy._path = copy._path.slice(0, path[1]).concat(copy._path.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._path.length) {
            return this;
          }
          const oldValue = this._path[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DataFieldUpgrade(this);
          copy._path = copy._path.slice();
          copy._path[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DataFieldUpgrade} other
   * @returns {DataFieldUpgrade}
   */
  merge(other) {
    const copy = new DataFieldUpgrade(this);
    if (other._hasValueType) {
      copy._hasValueType = true;
      copy._valueType = other._valueType;
    }
    if (other._hasValueGainsPerLevel) {
      copy._hasValueGainsPerLevel = true;
      copy._valueGainsPerLevel = other._valueGainsPerLevel;
    }
    if (other._assignedValueTypeCase === 4) {
      copy._assignedValueTypeCase = 4;
      copy._assignedValueTypeValue = other._assignedValueTypeValue;
    }
    if (other._assignedValueTypeCase === 4) {
      copy._assignedValueTypeCase = 4;
      copy._assignedValueTypeValue = other._assignedValueTypeValue;
    }
    copy._path = this._path.concat(other._path);
    return copy;
  }
}
DataFieldUpgrade.default = new DataFieldUpgrade();
DataFieldUpgrade.ValueType = DataFieldUpgrade_ValueType;
class DataFieldUpgrade_Builder {
  constructor(value) {
    this._value = new DataFieldUpgrade(value);
  }
  build() {
    return new DataFieldUpgrade(this._value);
  }
  setValueType(value) {
    this._value._hasValueType = true;
    this._value._valueType = value;
    return this;
  }
  deleteValueType() {
    this._value._hasValueType = false;
    this._value._valueType = null;
    return this;
  }
  setValueGainsPerLevel(value) {
    this._value._hasValueGainsPerLevel = true;
    this._value._valueGainsPerLevel = value;
    return this;
  }
  deleteValueGainsPerLevel() {
    this._value._hasValueGainsPerLevel = false;
    this._value._valueGainsPerLevel = null;
    return this;
  }
  clearassignedValueType() {
    this._value._assignedValueTypeCase = 0;
    this._value._assignedValueTypeValue = null;
    return this;
  }
  setFloatValue(value) {
    this._value._assignedValueTypeCase = 4;
    this._value._assignedValueTypeValue = value;
    return this;
  }
  setStringValue(value) {
    this._value._assignedValueTypeCase = 5;
    this._value._assignedValueTypeValue = value;
    return this;
  }
  addAllPath(values) {
    this._value._path = this._value._path.concat(values);
    return this;
  }
  addPath(value) {
    this._value._path = this._value._path.concat([value]);
    return this;
  }
  setPath(index, value) {
    this._value._path = this._value._path.concat();
    this._value._path[index] = value;
    return this;
  }
  clearPath() {
    this._value._path = [];
    return this;
  }
}
DataFieldUpgrade.Builder = DataFieldUpgrade_Builder;
class DataFieldUpgrade_WithParent {
  /**
   * @param {DataFieldUpgrade} value
   * @param {DataFieldUpgrade_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DataFieldUpgrade.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValueType() {
    if (this._cachedHasValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedHasValueType = true;
      } else {
        this._cachedHasValueType = this._parent ? this._parent.hasValueType : false;
      }
    }
    return this._cachedHasValueType;
  }
  get valueType() {
    if (this._cachedValueType === undefined) {
      if (this._value.hasValueType) {
        this._cachedValueType = this._value.valueType;
      } else {
        this._cachedValueType = this._parent ? this._parent.valueType : this._value.valueType;
      }
    }
    return this._cachedValueType;
  }
  get hasValueGainsPerLevel() {
    if (this._cachedHasValueGainsPerLevel === undefined) {
      if (this._value.hasValueGainsPerLevel) {
        this._cachedHasValueGainsPerLevel = true;
      } else {
        this._cachedHasValueGainsPerLevel = this._parent ? this._parent.hasValueGainsPerLevel : false;
      }
    }
    return this._cachedHasValueGainsPerLevel;
  }
  get valueGainsPerLevel() {
    if (this._cachedValueGainsPerLevel === undefined) {
      if (this._value.hasValueGainsPerLevel) {
        this._cachedValueGainsPerLevel = this._value.valueGainsPerLevel;
      } else {
        this._cachedValueGainsPerLevel = this._parent ? this._parent.valueGainsPerLevel : this._value.valueGainsPerLevel;
      }
    }
    return this._cachedValueGainsPerLevel;
  }
  get assignedValueTypeCase() {
    if (this._cachedassignedValueTypeCase === undefined) {
      if (this._value._assignedValueTypeCase === 0) {
        this._cachedassignedValueTypeCase = this._parent ? this._parent.assignedValueTypeCase : 0;
      } else {
        this._cachedassignedValueTypeCase = this._value._assignedValueTypeCase;
      }
    }
    return this._cachedassignedValueTypeCase;
  }
  get floatValue() {
    if (!this._cachedFloatValue) {
      if (this._value._assignedValueTypeCase === 0) {
        this._cachedFloatValue = this._parent ? this._parent.floatValue : this._value.floatValue;
      } else {
        this._cachedFloatValue = this._value.floatValue;
      }
    }
    return this._cachedFloatValue;
  }
  get stringValue() {
    if (!this._cachedStringValue) {
      if (this._value._assignedValueTypeCase === 0) {
        this._cachedStringValue = this._parent ? this._parent.stringValue : this._value.stringValue;
      } else {
        this._cachedStringValue = this._value.stringValue;
      }
    }
    return this._cachedStringValue;
  }
  get selfPath() {
    return this._value.path;
  }
  get inherentPath() {
    if (!this._inherentPath) {
      this._inherentPath = this._parent ? this._parent.path : [];
    }
    return this._inherentPath;
  }
  get path() {
    if (!this._allPath) {
      this._allPath = this._parent ? this._parent.path.concat(this.selfPath) : this.selfPath;
    }
    return this._allPath;
  }
  update(current, parent) {
    const result = new DataFieldUpgrade_WithParent(current, parent);
    return result;
  }
}
DataFieldUpgrade_WithParent.default = new DataFieldUpgrade_WithParent(DataFieldUpgrade.default, null);
DataFieldUpgrade.WithParent = DataFieldUpgrade_WithParent;
class DataFieldUpgrade_Descriptor {
  get valueType() {
    if (!this._valueType) {
      this._valueType = {
        name: "valueType",
        Name: "ValueType",
        number: 1,
        protoType: 14,
        protoName: "value_type",
        type: DataFieldUpgrade_ValueType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueType;
  }
  get valueGainsPerLevel() {
    if (!this._valueGainsPerLevel) {
      this._valueGainsPerLevel = {
        name: "valueGainsPerLevel",
        Name: "ValueGainsPerLevel",
        number: 2,
        protoType: 2,
        protoName: "value_gains_per_level",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._valueGainsPerLevel;
  }
  get floatValue() {
    if (!this._floatValue) {
      this._floatValue = {
        name: "floatValue",
        Name: "FloatValue",
        number: 4,
        protoType: 2,
        protoName: "float_value",
        oneofIndex: 2,
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._floatValue;
  }
  get stringValue() {
    if (!this._stringValue) {
      this._stringValue = {
        name: "stringValue",
        Name: "StringValue",
        number: 5,
        protoType: 9,
        protoName: "string_value",
        oneofIndex: 2,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stringValue;
  }
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 3,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Path is an array of nodes. Click the \"+\" button to add nodes to a path.",
          valueDropdown: "DataFieldUpgradePath",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.valueType,
        this.valueGainsPerLevel,
        this.floatValue,
        this.stringValue,
        this.path,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValueType",
        Name: "DummyOneofForValueType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValueGainsPerLevel",
        Name: "DummyOneofForValueGainsPerLevel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "assignedValueType",
        Name: "AssignedValueType",
        fields: [
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
DataFieldUpgrade.descriptor = new DataFieldUpgrade_Descriptor();
